import "./style.css";

export default class Rooms {
  static selector = ".rooms";

  constructor(block) {
    this.block = block;
    this.mounted = false;
  }

  onReady = () => {
    this.mounted = true;
  };

  onPageChangeComplete = () => {
    this.onComplete();
  };

  onComplete = () => {};
}
